module.exports = __webpack_public_path__ + "img/logo-ubiflow-2026-couleur-rvb.fa0b6a3e.png";